import React from 'react'
import { Navigate, Outlet,useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
function PrivateRoutes() {
    const location = useLocation();
    const {logged} = useSelector((data) => data.auth);
    return logged 
    ? <Outlet />
    : <Navigate to="/" replace state={{ from: location }} />;
}

export default PrivateRoutes;